<div class="modal-header">
  <h4 class="modal-title pull-left">Add note</h4>

  <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.hide()">
  </button>
</div>

<div class="modal-body">
  <textarea class="notes-textarea" rows="10" [(ngModel)]="note.content"></textarea>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-default" (click)="modalRef.hide()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="createNote()" [disabled]="disabled()">Add note</button>
</div>
